export const LOCALES = ["en", "es", "de", "fr", "pt", "it", "ca"] as const;
export type Locale = (typeof LOCALES)[number];

export const DEFAULT_LOCALE: Locale = "en";

export const LOCALE_LABELS: Record<Locale, string> = {
  en: "English",
  es: "Español",
  de: "Deutsch",
  fr: "Français",
  pt: "Português",
  it: "Italiano",
  ca: "Català",
};

export const LOCALE_TO_INTL: Record<Locale, string> = {
  en: "en-US",
  es: "es-ES",
  de: "de-DE",
  fr: "fr-FR",
  pt: "pt-PT",
  it: "it-IT",
  ca: "ca-ES",
};

export function isLocale(v: unknown): v is Locale {
  return typeof v === "string" && (LOCALES as readonly string[]).includes(v);
}

export function localeToIntl(lang: string): string {
  return isLocale(lang) ? LOCALE_TO_INTL[lang] : LOCALE_TO_INTL.en;
}
